import { ChatInterface } from '@/services/QA/chat/interfaces';
import { TicketInterface } from '@/services/QA/ticket/interfaces';
import { ChatEscalationInterface, TicketEscalationInterface } from '@/services/QA/escalation/interfaces';

export enum FeedbackType {
  FEEDBACK = 'feedback',
  CHAT = 'chat',
  TICKET = 'ticket',
}

export enum FeedbackStatus {
  SENT = 'sent',
  SEEN = 'seen',
  REPLIED = 'replied',
  ANSWERED = 'answered',
  CLOSED = 'closed',
}

export interface FeedbackDataInterface {
  status: FeedbackStatus;
  timestamp: number;
  feedbackFromUserId: string;
  feedbackToUsersIds: string[];
}

export interface ChatFeedbackInterface {
  chat: ChatInterface;
  chatId: string;
}

export interface TicketFeedbackInterface {
  ticketId: number,
  ticket: TicketInterface
}

export interface FeedbackInterface {
  id: number
  type: FeedbackType;
  status: FeedbackStatus;
  timestamp: number;
  chatId: string;
  ticketId: string;
  feedbackFromUserId: string;
  feedbackFromUserName: string;
  feedbackToUserId: string;
  feedbackToUserName: string;
  chatFeedback: ChatFeedbackInterface,
  ticketFeedback: TicketFeedbackInterface,

  [key: string]: string | number | ChatFeedbackInterface | TicketFeedbackInterface
}

export interface FeedbackResponseInterface {
  chat: ChatInterface,
  ticket: TicketInterface,
  feedback: FeedbackInterface
}

export default interface FeedbackRepositoryInterface {
  createChatFeedback(chatId: string, data: FeedbackDataInterface): Promise<void>;

  getAllFeedbacks(
    currentPage: number,
    sortBy: string,
    sortDesc: boolean,
  ): Promise<[FeedbackInterface[], number]>;

  getUserFeedbacks(userId: string): Promise<FeedbackInterface[]>;

  getOneById(id: number): Promise<FeedbackResponseInterface>;

  changeFeedbackStatus(id: number, status: FeedbackStatus): Promise<void>;

  searchFeedbacks(
    currentPage: number,
    search: string,
    sortBy: string,
    sortDesc: boolean,
  ): Promise<[FeedbackInterface[], number]>;
}
